import { useNavigate } from "react-router-dom";
import ThemeConstants from "../../../../config/theme/theme_constants";
import NewsGrid from "../components/news_grid";
import BackArrowIcon from '../../../../assets/images/back_arrow_icon.svg?react';
import { useBarColor } from "../../../../core/hooks/use_bar_color";
import { useTranslation } from "../../../../i18n/useTranslation";

const NewsPage: React.FC = () => {
  const { t } = useTranslation();
  const theme = ThemeConstants();
  const navigate = useNavigate();

  useBarColor('#FFFFFF');

  return (
    <div
      className="min-h-dvh w-full flex flex-col relative"
      style={{ 
        background: `linear-gradient(90deg, ${theme.UvibesPinkGradient} 0%, ${theme.UvibesRed} 100%)` 
      }}
      
    >
      <header className="flex flex-col items-center gap-1 pt-[6.5dvh] pb-[5.8dvh] relative text-white px-4">
          <h1 className="font-bold text-[40px] text-center leading-none text-ellipsis line-clamp-1 w-full">{t('news.title')}</h1>
          <p className="font-medium text-sm text-center text-ellipsis line-clamp-2 w-full">{t('news.subtitle')}</p>
          <BackArrowIcon className="absolute top-8 start-5 cursor-pointer" width={24} height={24} onClick={() => navigate(-1)}/>
      </header>
      <NewsGrid/>
    </div>
  );
};

export default NewsPage;